// How the office refers to a family in a sentence: "the Okafor Family", never
// "the Okafor Family family". Mirrors Family#label.
export function familyLabel(name: string): string {
  return /\bfamily$/i.test(name.trim()) ? name : `${name} family`;
}
